<ng-template #userDetail let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
  </div>
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      @for (error of errors; track error) {
        <div>
          <ngb-alert type="danger" (close)="closeError(error)">{{ error }}</ngb-alert>
        </div>
      }
      @if (isDuplicateUser) {
        <div class="alert alert-warning">The entered Email/Username is already in the list.  Use the Details Action to modify the User's information.</div>
      }
      @if (isAlreadyAssignedUser) {
        <div class="alert alert-warning">The entered Email/Username is already assigned to Agency '{{assignedAgency}}'.  A user can only be assigned to a single Agency.</div>
      }
      @if (addFromExistingUser) {
        <div class="alert alert-info">The entered Email/Username matches an existing User, and that User's Global information has been loaded.</div>
      }
      <ul ngbNav #userDetailNav="ngbNav" class="nav-tabs">
        <li ngbNavItem="account">
          <a ngbNavLink>Account</a>
          <ng-template ngbNavContent>
            <div class="form-group">
              <label for="username">Email/Username</label>
              <input type="text" id="username" formControlName="username" class="form-control" [class.is-invalid]="username.invalid && username.touched" [readonly]="!editUsername" (change)="onUsernameChange()" />
              @if (username.touched && username.hasError('required')) {
                <small class="text-danger">Email/Username is required</small>
              }
              @if (username.touched && username.hasError('email')) {
                <small class="text-danger">Email/Username is not a valid email address</small>
              }
              @if (username.touched && username.hasError('duplicate')) {
                <small class="text-danger">Email/Username already exists</small>
              }
            </div>
            <div class="form-group">
              <label for="first-name">First Name</label>
              <input type="text" id="first-name" formControlName="firstName" class="form-control" [class.is-invalid]="firstName.invalid && firstName.touched" [readonly]="!editName" (input)="onNameChange()" />
              @if (firstName.touched && firstName.hasError('required')) {
                <small class="text-danger">First Name is required</small>
              }
            </div>
            <div class="form-group">
              <label for="last-name">Last Name</label>
              <input type="text" id="last-name" formControlName="lastName" class="form-control" [class.is-invalid]="lastName.invalid && lastName.touched" [readonly]="!editName" (input)="onNameChange()" />
              @if (lastName.touched && lastName.hasError('required')) {
                <small class="text-danger">Last Name is required</small>
              }
            </div>
            <div class="form-group">
              <label for="display-name">Display Name</label>
              <input type="text" id="display-name" formControlName="displayName" class="form-control" readonly="readonly" />
            </div>
            <div class="form-group">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="allowLogin" formControlName="allowLogin" (change)="onAllowLoginChange()">
                <label class="form-check-label" for="allowLogin">Allow Login @if (accountAllowLoginHelpMessage) {
                  <i class="fa fa-question-circle" [ngbTooltip]="accountAllowLoginHelpMessage"></i>
                }</label>
              </div>
            </div>
          </ng-template>
        </li>
        @if (showApplicationSpecificFields) {
          <li ngbNavItem="application">
            <a ngbNavLink>Application</a>
            <ng-template ngbNavContent>
              @if (showAppAllowLogin) {
                <div class="form-group">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="allowAppLogin" formControlName="allowAppLogin" />
                    <label class="form-check-label" for="allowAppLogin">Allow Login @if (applicationAllowLoginHelpMessage) {
                      <i class="fa fa-question-circle" [ngbTooltip]="applicationAllowLoginHelpMessage"></i>
                    }</label>
                  </div>
                </div>
              }
              <div class="form-group">
                <label>Roles</label>
                <app-checkbox-group [options]="roleCheckboxItems" [selectedValues]="selectedRolesIn" (toggle)="onRolesToggle($event)"></app-checkbox-group>
              </div>
            </ng-template>
          </li>
        }
      </ul>
      <div [ngbNavOutlet]="userDetailNav"></div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="!userForm.valid || isDuplicateUser || isAlreadyAssignedUser">{{ acceptButtonCaption }}</button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    </div>
  </form>
</ng-template>
